import { render, staticRenderFns } from "./gsOrderList.vue?vue&type=template&id=e1c489c0&scoped=true&"
import script from "./gsOrderList.vue?vue&type=script&lang=js&"
export * from "./gsOrderList.vue?vue&type=script&lang=js&"
import style0 from "./gsOrderList.vue?vue&type=style&index=0&id=e1c489c0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1c489c0",
  null
  
)

export default component.exports